// extracted by mini-css-extract-plugin
export default {"container":"TbaContainer_container__uX3GC","empty":"TbaContainer_empty__t8EIw"};